import React from "react";
import { Filter } from "assets/icons";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface Props {
  children: React.ReactNode;
  isFilter: boolean;
  setIsFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

const FilterComponent: React.FC<Props> = ({
  children,
  isFilter,
  setIsFilter,
}) => {
  const toggleFilter = () => {
    setIsFilter((prev) => !prev);
  };

  return (
    <div>
      {/* Filter Toggle Button */}
      <Button
        variant="text"
        color="primary"
        onClick={toggleFilter}
        startIcon={
          <span
            style={{
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Filter />
          </span>
        }
        sx={{
          textTransform: "none",
          color: "#087fbc",
          fontSize: "14px",
          fontWeight: 500,
          "&:hover": {
            backgroundColor: "rgba(8, 127, 188, 0.04)",
          },
        }}
      >
        Filters
      </Button>

      {/* MUI Drawer */}
      <Drawer
        anchor="right"
        open={isFilter}
        onClose={() => setIsFilter(false)}
        PaperProps={{
          sx: {
            width: 400,
            height: "70vh", // 👈 make it half/shorter height
            top: "20vh", // 👈 push it down to center vertically
            borderRadius: "12px 0 0 12px", // rounded left corners
            display: "flex",
            flexDirection: "column",
          },
        }}
        ModalProps={{
          keepMounted: true, // improves performance
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 3,
            py: 2,
            borderBottom: "1px solid #e0e0e0",
            bgcolor: "#f9fafb",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontSize: "16px", fontWeight: 600, color: "#333" }}
          >
            Filters
          </Typography>
          <IconButton
            onClick={() => setIsFilter(false)}
            size="small"
            sx={{
              color: "#666",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>{children}</Box>
      </Drawer>
    </div>
  );
};

export default FilterComponent;
